
<template>

    <v-container fluid fill-height class="no-padding">

        <v-layout wrap fill-height>

            <v-container v-if="loading" fluid fill-height class="loader-absolute bg-grey">
                <div style="position: fixed;left: 0;right:0;">
                    <v-progress-circular style="margin: auto;"
                            :size="200"
                            :width="7"
                            color="primary"
                            :value="value"
                    >
                        {{ $t("Loading...") }}
                    </v-progress-circular>
                </div>
                <div class="primary--text" style="position: fixed;left: 0;right: 0;padding-top: 250px;margin-left: 5px;margin-right: 5px;">{{ $t("Loading takes a couple of seconds because we're protecting your document through blockchain") }}</div>
            </v-container>

            <v-container fluid fill-height class="no-padding">

                <v-layout column fill-height style="height: 100%;display: flex;flex-direction: column;">

                    <v-toolbar color="white" light  style="flex: 0 1 90px;z-index: 2;" class="elevation-1">

                        <v-layout row>
                            <div style="max-width: calc(100% - 90px);" class="text-xs-left">
                                <v-toolbar-title class="no-selectable">{{file.name}}</v-toolbar-title>
                                <TemporaryText :temporary="file.temporary"></TemporaryText>
                            </div>

                            <v-spacer></v-spacer>

                            <v-btn v-if="file.download"
                                   icon @click="downloadFile"
                                   :loading="downloading"
                                   :disabled="downloading"
                            >
                                <v-icon>cloud_download</v-icon>
                            </v-btn>

                            <v-btn icon @click="showFileInfo">
                                <v-icon>info</v-icon>
                            </v-btn>

                            <v-btn icon @click="showHistory">
                                <v-icon>history</v-icon>
                            </v-btn>

                            <v-btn icon @click="showChat">
                                <v-icon>chat</v-icon>
                            </v-btn>

                        </v-layout>

                    </v-toolbar>

                    <ViewerError v-if="showError" :fullWidth="!drawer" class="viewer" :file="file"/>

                    <PdfViewer v-else-if="isPdf" v-on:loaded="fileLoaded" class="viewer" v-on:error="processServerError" :hash="file.hash" :token="token" :fullWidth="!drawer" :file="file"/>

                    <ImageViewer v-else-if="isImage" v-on:loaded="fileLoaded" class="viewer"  v-on:error="processServerError" :hash="file.hash" :token="token" :fullWidth="!drawer" :email="my_email"/>

                    <LargeModelViewer v-else-if="isModel" v-on:loaded="fileLoaded" class="viewer" v-on:error="processServerError" :hash="file.hash" :token="token" :fullWidth="!drawer"/>

                    <TemporalPermissionsEnded  v-else-if="showTemporal" class="viewer" :hash="file.hash" :token="token" :fullWidth="!drawer" :file="file"/>

                </v-layout>

            </v-container>

            <v-navigation-drawer
                    v-model="drawer"
                    right absolute
                    hide-overlay
                    stateless
                    width="500">

                <FileInfoDrawer ref="drawer" v-on:close="toggleDrawer" :file="file" :token="token"/>

            </v-navigation-drawer>

        </v-layout>
    </v-container>

</template>

<script>

    import { VLayout, VContainer, VNavigationDrawer, VBtn, VIcon, VToolbar, VToolbarTitle, VSpacer, VProgressCircular } from 'vuetify/lib'
    import FileInfoDrawer from "../components/FileInfoDrawer";
    import TemporalPermissionsEnded from "../components/TemporalPermissionsEnded";
    import ViewerError from "../components/ViewerError";
    import PdfViewer from "../components/Viewers/PdfViewer";
    import ImageViewer from "../components/Viewers/ImageViewer";
    import LargeModelViewer from "../components/Viewers/LargeModelViewer";
    import FilesRepository from '../repositories/FilesRepository';
    import TemporaryText from "../components/TemporaryText";
    import LocalRepository from '../repositories/LocalRepository';

    const convertibleFileExtensions = ['.doc', '.docx', '.odt', '.ods', '.xlsx', '.xls', '.odp', '.pptx','.ppt', '.txt','.rtf','.odg'];//This array is repeated at RenderCore.js
    const imageExtensions = ['.jpg', '.png', '.jpeg', 'jfif'];

    export default {
        name: 'Viewer',
        components:{
            TemporalPermissionsEnded,
            TemporaryText,
            LargeModelViewer,
            ImageViewer,
            PdfViewer,
            ViewerError,
            FileInfoDrawer, VLayout, VContainer, VNavigationDrawer, VBtn, VIcon, VToolbar, VToolbarTitle, VSpacer, VProgressCircular },
        created() {
            // Check if we have a token in header
            if (this.$route.params.token) {
                this.token = this.$route.params.token;
                this.logout();
            }

            // Load the file info
            this.getFileInfo();

            this.$root.$on('download-file', (event) => {
                this.downloadFile();
            });
        },
        mounted() {
            var seconds_to_finish = 1;
            this.interval = setInterval(() => {
                if (this.value < 100) {
                    this.value += 1;
                } else {
                    clearInterval(this.interval);
                }
            }, 1000)
        },
        beforeDestroy () {
            clearInterval(this.interval)
        },
        data () {
            return {
                // General loading
                loading: true,
                interval: {},
                value: 0,

                // Drawer toggle
                drawer: false,

                // File Info
                file: {
                    name: "",
                    hash: "",
                    type: "",
                    download: false,
                    size: 0,
                    pages: 0,
                    creationDate: true,
                    creator: {
                        address: "",
                        name: "",
                        email: ""
                    },
                    temporary: null
                },

                // My email
                my_email: "",

                // The token in url
                token: null,

                // Downloading
                downloading: false,

                // Type booleans
                isPdf: false,
                isImage: false,
                isModel: false,

                showTemporal: false,
                showError: false
            }
        },
        methods: {
            getFileInfo() {
                FilesRepository.getFileInfo(this.$route.params.hash, this.token)
                    .then((response)=>{
                        if (response && response.data && response.data.file) {

                            if (this.checkTemporaryAccessEnd(response.data.file)) {
                                this.showTemporal = true;
                                this.fileLoaded();
                            } else {
                                this.checkFileType(response.data.file);
                            }

                            this.$nextTick(() => {
                                this.file = response.data.file;
                                this.my_email = response.data.user_email;
                            });

                        }
                    })
                    .catch((error)=>{
                        this.processServerError(error)
                    });
            },
            fileLoaded() {
                this.loading = false;
            },
            fileError() {
                this.loading = false;
                this.showError = true;
            },
            checkTemporaryAccessEnd(file) {
                if (file.temporary) {
                    if (file.temporary.type === 'load') {
                        return file.temporary.current < 1;
                    }
                }
                return false;
            },
            checkFileType(file) {
                console.log(file.type);

                this.isPdf = file.type.includes("application/pdf") || file.name.substring(file.name.lastIndexOf('.'))==='.pdf'
                if (!this.isPdf) this.isPdf = convertibleFileExtensions.includes(file.name.substring(file.name.lastIndexOf('.')));
                this.isImage = file.type.startsWith("image/") || imageExtensions.includes(file.name.substring(file.name.lastIndexOf('.')));
                this.isModel = !this.isPdf && !this.isImage;
                if (file.type == "application/zip" || file.type.indexOf("x-zip") > -1 || file.type.indexOf(".zip") > -1) this.isModel = false;
                if (!this.isPdf && !this.isImage && !this.isModel) {
                    this.showError = true;
                    this.loading = false;
                }
            },
            showFileInfo() {
                this.$refs.drawer.setTab("tab-info");
                this.toggleDrawer();
            },
            showHistory() {
                this.$refs.drawer.setTab("tab-history");
                this.toggleDrawer();
            },
            showChat() {
                this.$refs.drawer.setTab("tab-chat");
                this.toggleDrawer();
            },
            toggleDrawer() {
                this.drawer = !this.drawer;
            },
            downloadFile() {
                this.downloading = true;
                FilesRepository.getOriginalFile(this.$route.params.hash, this.token)
                    .then((response)=>{

                        const filename = response.headers['content-name'];
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');

                        link.href = url;
                        link.setAttribute('download', filename);
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode.removeChild(link);

                    })
                    .catch((error)=>{
                        this.$root.$emit('show-snackbar', {message: this.$t('You are not allowed to download this content'), color: 'danger', timeout: 6000 });
                    })
                    .finally(()=>{
                        this.downloading = false;
                        this.$root.$emit('downloaded-file');
                    });
            },
            processServerError(error) {
                // Not authorized
                if (error.response && error.response.status === 401) {
                    this.$router.push({name: 'error', params: {message: error.response.data.message}});
                }
                // Not found
                else if (error.response && error.response.status === 404) {
                    this.$router.push({name: 'error', params: {message: error.response.data.message}});
                }
                // Server error
                else {
                    if (error.response && error.response.data && error.response.data.message) {
                        console.error(error.response.data.message);
                    } else {
                        console.error(error);
                    }
                    this.fileError();

                }
            },
            logout() {
                LocalRepository.clear("token");
                this.$user = null;
            }
        }
    };
</script>
<style scoped>
    .viewer {
        width: 100%;flex: 1 1 auto;overflow: hidden;display: flex;
    }
</style>
